import { render, staticRenderFns } from "./CustomerTicketVolumeChart.vue?vue&type=template&id=a0cc94c6&scoped=true&"
import script from "./CustomerTicketVolumeChart.vue?vue&type=script&lang=js&"
export * from "./CustomerTicketVolumeChart.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTicketVolumeChart.vue?vue&type=style&index=0&id=a0cc94c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cc94c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0cc94c6')) {
      api.createRecord('a0cc94c6', component.options)
    } else {
      api.reload('a0cc94c6', component.options)
    }
    module.hot.accept("./CustomerTicketVolumeChart.vue?vue&type=template&id=a0cc94c6&scoped=true&", function () {
      api.rerender('a0cc94c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales/CustomerTicketVolumeChart.vue"
export default component.exports